import React from 'react'
import intl from 'react-intl-universal'
import { connect } from 'react-redux'
import { getForm } from '../actions/RmaActions'
import { getQueries } from '../utils/Tools'

const mapStateToProps = state => ({
  authenticated: state.auth.session.id !== false,
  lang: state.auth.lang
})

const mapDispatchToProps = dispatch => ({
  getFormAction: (formCode, id) => dispatch(getForm(formCode, id))
})

class SearchComponent extends React.Component {
  constructor(props) {
    super();
    // ERP moze otworzyc panel z kodem za '#' (rma_panel zakonczone '/#'),
    // a selectLang przenosi go do location.search dopiero po zamontowaniu,
    // wiec czytamy przez getQueries, ktore obsluguje obie postacie.
    this.state = {
      formCode: getQueries().code || ''
    };
  }

  componentDidMount() {
    const { formCode } = this.state;

    if (formCode) {
      this.props.getFormAction(formCode, parseInt(getQueries().id) || null);
    } else {
      document.getElementById('formCode').focus();
    }
  }

  handleChange = (event) => {
    const {target} = event
    this.setState({
      [target.name]: target.value
    })
  }

  handleKey = (event) => {
    if (event.which === 13) {
      this.handleSubmit(event)
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { getFormAction } = this.props
    const {target} = event
    const field = target.dataset.field
    const kod = this.state[field]
    if (kod){
      getFormAction(kod)
    }
  }

  render() {
    const formCode = this.state.formCode;
    return (
      <div className="container">
        <form onSubmit={this.handleSubmit} data-field="formCode">
          <div className="ramka center searchForm">
            <h4>{intl.get('Obsługa RMA')}</h4>
            <div>
              <input
                type='text'
                name='formCode'
                id='formCode'
                placeholder={intl.get('Kod z formularza / nr zamówienia / Nazwisko')}
                autoComplete='off'
                onChange={this.handleChange}
                value={formCode ? formCode : ''}
                />
              <input type="submit" value={intl.get('Dalej')}/>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const Search = connect(mapStateToProps, mapDispatchToProps)(SearchComponent)
export default Search
